import { isNull } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const TableHeader = [
  "HV Amount",
  "TDS",
  "Net Amount",
  "Payable Amount",
  "Advance Amount",
  "Test Details",
  "Additional Tests",
  "Package",
  "Refund Amount",
  "Remarks",
  "Appointment Closed By",
  "Appointment Closed Date",
  "Closed Counts",
  "Month",
  "Invoice Amount",
  "Invoice No",
  "Adjustment Type",
  "Adjustment Amount",
  "Adjustment Remarks",
];
const payableHeader = ["HV Amount", "TDS %","TDS Amount", "Over All Discount", "Client Name"];
const InsPayableHeader = [
  "HV Amount",
  "GST",
  "Service Charge",
  "Insurer Amount",
  // "Client Name",/
];

const addInsurerHeader = [
  "Home Visit Amount",
  "Service Charges",
  "Adjustment Amount",
  "Gross Amount",
  "Docket No",
  "Test Details",
  "Additional Tests",
  "Package",
  "Propser Name",
  // "Insurer Request Status",
  "Insurer Edit Remarks",
  "Insurer Remarks",
  "Appointment Closed By",
  "Appointment Closed Date",
  "Closed Counts",
  "Month",
];
const ClientHeader = ["Home visit Amount", "service Charge", "Adjust Amount"];

const providerPayoutHeader = [
  "Advance Amount",
  "Payable Amount",
  "Adjustment Type",
  "Adjustment Amount",
];

const insurerDashboard = [
  "Service Charges",
  "Adjustment Amount",
  "Test Details",
  "Additional Tests",
  "Package",
  "Month",
  "Status",
  "Docket No",
  "Remark",
];
export let payOutHeaderValue = {
  "Propser Name": "proposerName",
  "Advance Amount": "advanceAmount",
  "Payable Amount": "payableAmount",
  "Split Amount": "splitIndividualTestAmount",
  "Photograph Amount": "photographAmount",
  "Docket No": "docketNo",
  "Test Details": "tests",
  "HV Amount": "homeVisitAmount",
  "Insurer Amount": "insurerAmount",
  "Customer Amount": "customerAmount",
  Package: "packages",
  "Additional Tests": "additionalTest",
  "Advance Amount": "advanceAmount",
  TDS: "tds",
  "Net Amount": "netAmount",
  "Gross Amount": "netAmount",
  "Provider Amount": "totalAmount",
  "Client Name": "clientName",
  "Provider ID": "providerId",
  "Photograph Amount": "photographAmount",
  "Split Amount": "splitIndividualTestAmount",
  "Docket No": "docketNo",
  "Case No": "caseNo",
  "Refund Amount": "refundAmount",
  Remarks: "remarks",
  "Finance TDS": "financeTDS",
  "Finance Amount": "financeAmount",
  "Provider Amount": "totalAmount",
  "Finance HV Amount": "financeHVAmount",
  "Appointment Closed By": "appointmentClosedBy",
  "Appointment Closed Date": "appointmentClosedDate",
  "Closed Counts": "closedCounts",
  Month: "",
  "Payable Amount": "payableAmount",
  tests: "Tests",
  insurerSum: "insurerSum",
  "Service Charges": "serviceCharges",
  GST: "gst",
  "Insurer Request Status": "insurerRequestStatus",
  "Insurer Remarks": "insurerRemarks",
  "Home Visit Amount": "homeVisitSum",
  "Service Charge": "serviceCharge",
  "HV Amount": "homeVisitAmount",
  "Adjustment Amount": "adjustAmount",
  "Adjustment Type": "adjustmentType",
  "Adjustment Remarks": "adjustmentRemarks",
  Status: "insurerRequestStatus",
  Remark: "insurerRemarks",
  "Insurer Edit Remarks": "insurerEditRemarks",
  "Invoice Amount": "invoiceAmount",
  "Invoice No": "invoiceNo",
  "Over All Discount": "overAllDiscount",
  "TDS %": "tdsPercentage",
  "TDS Amount": "tds"
};
export const AdditionalApptHeader = ({
  switchTab,
  header,
  setHeader,
  searchFilter,
  setIsOpenSetting,
}) => {
  const location = useLocation();
  const [selectHeader, setSelectHeader] = useState([]);
  console.log("location", location);
  console.log("searchFilter For Testing payable Setting Icon", searchFilter);

  useEffect(() => {
    if (switchTab === "totalProviders") {
      setSelectHeader(providerPayoutHeader);
    } else if (location.pathname === "/payout/networkpayout") {
      setSelectHeader(TableHeader);
    } else if (location.pathname === "/payout/Payables") {
      setSelectHeader(payableHeader);
    } else if (switchTab === "totalClient") {
      setSelectHeader(InsPayableHeader);
    } else if (location?.pathname === "/insurer/Receivables") {
      setSelectHeader(InsPayableHeader);
    } else if (location.pathname === "/insurer/insurerbilling") {
      setSelectHeader(addInsurerHeader);
    } else if (location.pathname === "/insurer/insurerdashboard") {
      setSelectHeader(insurerDashboard);
    }
    if (
      searchFilter?.BusinessType === "IBU" &&
      switchTab !== "totalProviders" &&
      location.pathname !== "/payout/Payables"
    ) {
      setSelectHeader([
        "HV Amount",
        "TDS",
        "Net Amount",
        "Payable Amount",
        "Advance Amount",
        "Test Details",
        "Additional Tests",
        "Package",
        "Refund Amount",
        "Remarks",
        "Appointment Closed By",
        "Appointment Closed Date",
        "Closed Counts",
        "Month",
        "Photograph Amount",
        "Split Amount",
        "Docket No",
        "Case No",
        "Adjustment Type",
        "Adjustment Amount",
        "Adjustment Remarks",
      ]);
    }
    console.log(selectHeader);
  }, [location, switchTab]);

  const handleSelectAll = (e) => {
    if (switchTab === "totalProviders") {
      e.target.checked ? setHeader(providerPayoutHeader) : setHeader([]);
    } else if (location.pathname === "/payout/networkpayout") {
      e.target.checked ? setHeader(selectHeader) : setHeader([]);
    } else if (location.pathname === "/payout/Payables") {
      e.target.checked ? setHeader(payableHeader) : setHeader([]);
    } else if (location?.pathname === "/insurer/Receivables") {
      e.target.checked ? setHeader(InsPayableHeader) : setHeader([]);
    } else if (location.pathname === "/insurer/insurerbilling") {
      e.target.checked ? setHeader(addInsurerHeader) : setHeader([]);
    } else if (location.pathname === "/insurer/insurerdashboard") {
      e.target.checked ? setHeader(insurerDashboard) : setHeader([]);
    }
  };

  return (
    <>
      <div>
        <div
          className="d-flex justify-content-between border-bottom modalHeader"
          style={{ borderRadius: "10px 10px 0px 0px" }}
        >
          <h4 className="font-bold text-black">Choose To Filter Table</h4>
          <button
            type="button"
            className="btn-close history-close"
            aria-label="Close"
            data-bs-dismiss="modal"
            onClick={() => {
              setIsOpenSetting(false);
            }}
          ></button>
        </div>
        <div className="select-time-interval ps-3 pe-3" id="andimni">
          {selectHeader?.length > 0 && (
            <>
              {selectHeader?.map((ele, index) => (
                <div className="d-flex gap-3">
                  <div style={{ fontSize: "15px", padding: "3px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={header?.some((element) => element === ele)}
                      onClick={(e) => {
                        if (e.target.checked) {
                          setHeader([...header, ele]);
                        } else {
                          let arr = header.filter((item) => item !== ele);
                          setHeader(arr);
                        }
                      }}
                    />
                  </div>
                  <label style={{ fontSize: "13px", padding: "3px" }}>
                    {ele}
                  </label>
                </div>
              ))}
            </>
          )}
        </div>
        <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0">
          <div>
            <input
              type="checkbox"
              className="form-check-input"
              onClick={(e) => {
                handleSelectAll(e);
              }}
              checked={
                location.pathname === "/payout/networkpayout" &&
                (switchTab === "unSuccessfullAppointments" ||
                  switchTab === "totalApppointments")
                  ? header?.length === selectHeader.length
                  : switchTab === "totalProviders"
                  ? header?.length === providerPayoutHeader.length
                  : location.pathname === "/insurer/insurerbilling" &&
                    (switchTab === "unSuccessfullAppointments" ||
                      switchTab === "totalApppointments")
                  ? header?.length === addInsurerHeader?.length
                  : location?.pathname === "/insurer/Receivables"
                  ? header?.length === InsPayableHeader.length
                  : location?.pathname === "/insurer/insurerdashboard"
                  ? header?.length === insurerDashboard.length
                  : header?.length === payableHeader.length
              }
            />
            <label
              className="margin-right"
              style={{ marginLeft: "10px", fontWeight: "600" }}
            >
              Select All
            </label>
          </div>
          <div>
            <button
              type="button"
              className="savedetails"
              aria-label="Close"
              data-bs-dismiss="modal"
              onClick={() => {
                setIsOpenSetting(false);
              }}
            >
              Show Selected
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
